import React, { useState } from "react";
import { Link } from "react-router-dom";
import blogs from "../constants/blogs";

const Blog = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const blogsPerPage = 3;

    const indexOfLast = currentPage * blogsPerPage;
    const indexOfFirst = indexOfLast - blogsPerPage;
    const currentBlogs = blogs.slice(indexOfFirst, indexOfLast);

    const totalPages = Math.ceil(blogs.length / blogsPerPage);

    return (
        <div className="container mx-auto px-4 py-8 mt-12 md:mt-14">
            <h1 className="text-3xl font-bold mb-6 text-center">Our Blogs</h1>

            <div className="grid md:grid-cols-3 gap-6">
                {currentBlogs.map((blog) => (
                    <div
                        key={blog.id}
                        className="border rounded-lg shadow-lg p-4 bg-white"
                    >
                        <img
                            src={blog.featuredImage}
                            alt={`blog name :${blog.title}`}
                            title={`blog name :${blog.title}`}
                            className="h-48 w-full object-cover rounded-md"
                        />
                        <h2 className="text-xl font-semibold mt-3">{blog.title}</h2>
                        <p className="text-gray-600 mt-2">{blog.excerpt}</p>
                        <Link
                            to={`/blog/${blog.slug}`}
                            className="text-red-600 font-medium mt-3 block"
                        >
                            Read More →
                        </Link>
                    </div>
                ))}
            </div>

            {/* Pagination */}
            <div className="flex justify-center mt-6 space-x-2">
                {[...Array(totalPages).keys()].map((num) => (
                    <button
                        key={num}
                        onClick={() => setCurrentPage(num + 1)}
                        className={`px-4 py-2 rounded ${currentPage === num + 1
                            ? "bg-red-600 text-white"
                            : "bg-gray-200 text-gray-700"
                            }`}
                    >
                        {num + 1}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default Blog;
